import { lazy } from "react";

// Like React.lazy, but the returned component also exposes .preload() so its
// chunk can be fetched ahead of navigation. Calling preload() repeatedly is safe
// (the dynamic import is module-cached after the first call).
export function lazyWithPreload(factory) {
  const Component = lazy(factory);
  Component.preload = factory;
  return Component;
}
